module.exports = __webpack_public_path__ + "img/green.83f7d33e.jpg";